import { defineProviderCapability } from "./define-provider-capability";

// Mobile-only UI feature flags. No env vars / resources — pure runtime
// gates the mobile app uses to show/hide internal UI.
export const mobileApp = defineProviderCapability("mobileApp", {
  // Hidden screen that lets internal preview-capable builds switch to a
  // PR EAS Update channel. Available in preview, blocked in production
  // (no stable build should expose the switcher).
  previewChannelSwitcher: {
    scope: "runtime",
    environments: {
      local: { mode: "managed" },
      preview: { mode: "managed" },
      production: {
        mode: "not-applicable",
        note: "Stable builds must not expose the preview channel switcher.",
      },
    },
  },
});
